import { render, staticRenderFns } from "./ClassPage.vue?vue&type=template&id=2d0b2781&scoped=true&"
import script from "./ClassPage.vue?vue&type=script&lang=js&"
export * from "./ClassPage.vue?vue&type=script&lang=js&"
import style0 from "./ClassPage.vue?vue&type=style&index=0&id=2d0b2781&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b2781",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VMain,VProgressCircular})
